import { TERMINE_TERMIN_CREATE } from '@/domain/termine/hooks/graphql/mutation';
import { FormValues } from '@/domain/termine/shared/types/CreateTermineInput';
import { toGraphQLMarkierung } from '@/domain/termine/shared/types/Markierung';
import { wiederholungToGraphQLMap } from '@/domain/termine/shared/types/TerminWiederholung';
import {
  CreateTerminMutation,
  CreateTerminMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client';

type CreateTerminProps = {
  managerId: string;
  termin: FormValues;
};

export function useCreateTermine() {
  const [mutate, { data, loading }] = useMutation<
    CreateTerminMutation,
    CreateTerminMutationVariables
  >(TERMINE_TERMIN_CREATE, {
    refetchQueries: ['GetTagesDaten'],
    awaitRefetchQueries: true,
  });

  const createTermin = async (props: CreateTerminProps) => {
    const result = await mutate({
      variables: {
        managerId: props.managerId,
        termin: {
          datum: props.termin.datum,
          titel: props.termin.titel,
          beschreibung: props.termin.beschreibung,
          specials: props.termin.specials,
          standortId: props.termin.standortId,
          terminKalenderId: props.termin.terminKalenderId,
          markierung: toGraphQLMarkierung(props.termin.markierung),
          wiederholung: wiederholungToGraphQLMap[props.termin.wiederholung],
          beginn: props.termin.beginn,
          ende: props.termin.ende,
          wiederholungBis: props.termin.wiederholungBis,
          terminImage: props.termin.terminBildInput,
        },
      },
    });
    return result.data?.termine_terminCreate;
  };

  return {
    createTermin,
    response: data?.termine_terminCreate,
    loading,
  };
}
